// src/api/equipements.js
import { CONFIG } from '../config/config';

function authHeaders() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
}

export async function listEquipements() {
  const r = await fetch(`${CONFIG.API_URL}/equipements`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}

export async function createEquipement(payload) {
  const r = await fetch(`${CONFIG.API_URL}/equipements`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateEquipement(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/equipements/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function deleteEquipement(id) {
  const r = await fetch(`${CONFIG.API_URL}/equipements/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

/**
 * Déclenche l'ouverture d'une armoire médicale (proxy back → Home Assistant)
 * @param {string} id - UUID de l'équipement
 */
export async function triggerEquipementArmoire(id) {
  const r = await fetch(`${CONFIG.API_URL}/equipements/${id}/trigger`, {
    method: 'POST',
    headers: authHeaders(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}
